import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AbstractHttpService } from "./http-abstract.service";
import { Observable } from "rxjs";
import { CloudflareResponse } from "./dtos";

@Injectable({
	providedIn: "root",
})
export class HttpCloudflareService extends AbstractHttpService {
	constructor(http: HttpClient) {
		super(http);
	}

	public verify(token: string): Observable<CloudflareResponse> {
		const path = `/cloudflare-turnstile/verify`;
		return super.post<CloudflareResponse>(path, { token });
	}
}
